export const UPDATE_DP_SOA_ACTIVITIES = "UPDATE_DP_SOA_ACTIVITIES";
export const UPDATE_DP_FOOTNOTE_CONFIG_DATA = "UPDATE_DP_FOOTNOTE_CONFIG_DATA";
export const UPDATE_DP_FOOTNOTE_DATA = "UPDATE_DP_FOOTNOTE_DATA";
export const UPDATE_DP_FOOTNOTE_SOFT_SAVE = "UPDATE_DP_FOOTNOTE_SOFT_SAVE";
export const CLEAR_DP_FOOTNOTE_SOFT_SAVE = "CLEAR_DP_FOOTNOTE_SOFT_SAVE";
export const UPDATE_DP_FINALIZE_STATUS = "UPDATE_DP_FINALIZE_STATUS";

export const FOOTNOTE_TYPE_CHECK = {
  IS_PATIENT_POPULATION: "IS_PATIENT_POPULATION",
  IS_SUB_ACTIVITY: "IS_SUB_ACTIVITY",
  IS_DIFFERENT_WORKFLOW: "IS_DIFFERENT_WORKFLOW",
  IS_REPEAT_IN_CERTAIN_CASE: "IS_REPEAT_IN_CERTAIN_CASE",
  IS_CONTINUOUSLY_MONITORED: "IS_CONTINUOUSLY_MONITORED",
  IS_MULTIPLE_MODALITIES: "IS_MULTIPLE_MODALITIES",
  IS_FREE_TEXT: "IS_FREE_TEXT",
  IS_CONTINUOUSLY_MONITORED_FOR_VISIT: "IS_CONTINUOUSLY_MONITORED_FOR_VISIT",
};

export const FOOTNOTE_GROUP = {
  ACTIVITY: "Activity",
  VISIT: "Visit",
  CELL: "Cell",
  PERIOD: "Period",
};

export const SOFT_SAVE_ID_PREFIX = "softSave";
